/* do-not-disable-eslint
    react/display-name,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react'

const NotFound = () => (
  <main className="modal-page-content">
    <div className="container">
      <h1>404 - Not Found</h1>
      <div className="flow-text">That's unfortunate. Where did it go?</div>
    </div>
  </main>
)
export default NotFound
